import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setLogInData } from "./LogIn";
import {setSessionData} from "../utils/session";

/**
 * Landing route for the SAML 2.0 POST-back flow.
 *
 * Azure AD POSTs the SAML assertion to your *backend* at /saml/callback.
 * The backend validates it, creates a short-lived token, then redirects
 * here with:  /saml/callback?token=<jwt>&userId=<id>&...
 *
 * This component picks up those query params, persists the session, and
 * sends the user to the dashboard — exactly as the password login does.
 */
export default function SamlCallback() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState("");

    useEffect(() => {
        const token= searchParams.get("token");
        const user= searchParams.get("user");
        const userId= searchParams.get("userId");
        const xtvmAllowed = searchParams.get("xtvmAllowed") === "true";
        const altDataAllowed = searchParams.get("altDataAllowed") === "true";
        const ibmAllowed = searchParams.get("ibmAllowed") === "true";
        const ibmRestricted = searchParams.get("ibmRestricted") === "true";

        if (!token) {
            navigate("/", { replace: true });
            return;
        }

        setSessionData({
            token,
            user,
            userId,
            userName: user,
            ibmToken: "",
            profilerUrl: process.env.REACT_APP_PROFILER_URL || "",
            xtvmAllowed,
            altDataAllowed,
            ibmAllowed,
            ibmRestricted,
        });

        navigate("/dashboard", { replace: true });
    }, []);

    return (
        <div className="landing-container">
            {error ? (
                <div className="login-error">{error}</div>
            ) : (
                <p>Completing SSO sign-in…</p>
            )}
        </div>
    );
}